export default "__VITE_ASSET__CQ0Irrgy__"